// src/components/menu/AMItem.tsx

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { ReactNode } from 'react'

type AMItemProps = {
  caption?: string
  disabled?: boolean
  icon?: ReactNode
  onClick?: () => void
  selected?: boolean
}

export const AMItem = ({
  caption,
  disabled = false,
  icon,
  onClick,
  selected = false,
  ...rest
}: AMItemProps) => (
  <MenuItem onClick={onClick} selected={selected} disabled={disabled} {...rest}>
    <ListItemIcon>{icon}</ListItemIcon>
    <ListItemText>{caption}</ListItemText>
  </MenuItem>
)
